import { Button } from '@/components/ui/button';
import { WhatsappLogo, Envelope } from '@phosphor-icons/react';
import { CONTACT } from '@/lib/constants';

const ADVISOR_WHATSAPP = `https://wa.me/${CONTACT.WHATSAPP_RAW}?text=${encodeURIComponent(
`Hello Aurea Digital Solutions.

I would like to discuss my AWSAI assessment results with an advisor.

Organisation:
Contact Person:
Email:
Phone:
Topic of Interest:

Please advise on the next steps.`
)}`;

const ADVISOR_EMAIL = `mailto:${CONTACT.EMAIL}?subject=${encodeURIComponent(
  'AWSAI Results Discussion'
)}&body=${encodeURIComponent(
`Dear Aurea Digital Solutions,

I would like to discuss my AWSAI assessment results with an advisor.

Organisation:
Contact Person:
Email:
Phone:
Topic of Interest:

Please advise on the next steps.

Thank you.`
)}`;

const ConsultationSection = () => (
  <section
    className="py-20 lg:py-28 bg-gradient-to-br from-slate-900 via-slate-900 to-teal-900 text-white"
    id="advisor"
    data-testid="consultation-section"
  >
    <div className="max-w-4xl mx-auto px-6 lg:px-12 text-center">
      <div className="text-[11px] tracking-[0.22em] uppercase font-bold text-teal-300 mb-3">
        Talk to an Advisor
      </div>
      <h2 className="text-3xl sm:text-4xl tracking-tight font-black mb-5">
        Discuss Your Results With an Advisor
      </h2>
      <p className="text-slate-200 leading-relaxed mb-3 max-w-2xl mx-auto text-base">
        Every organisation has different operational challenges, priorities, and readiness levels.
      </p>
      <p className="text-slate-300 leading-relaxed mb-8 max-w-2xl mx-auto text-[15px]">
        If you would like help interpreting your AWSAI results, identifying priority workflows,
        or planning the next stage of improvement, you may contact Aurea Digital Solutions for a
        consultation.
      </p>
      <div className="flex flex-col sm:flex-row gap-3 justify-center mb-6">
        <Button asChild size="lg" className="bg-green-600 hover:bg-green-700 text-white font-semibold">
          <a
            href={ADVISOR_WHATSAPP}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="consultation-whatsapp-button"
          >
            <WhatsappLogo size={20} weight="fill" className="mr-2" />
            WhatsApp Aurea Digital Solutions
          </a>
        </Button>
        <Button asChild size="lg" variant="outline" className="border-2 border-white text-white hover:bg-white/10">
          <a href={ADVISOR_EMAIL} data-testid="consultation-email-button">
            <Envelope size={20} weight="bold" className="mr-2" />
            Email Aurea Digital Team
          </a>
        </Button>
      </div>
      <div className="text-xs text-slate-400">
        {CONTACT.COMPANY} · {CONTACT.WHATSAPP_NUMBER} · {CONTACT.EMAIL}
      </div>
    </div>
  </section>
);

export default ConsultationSection;
